import { Anchor, Image } from "@mantine/core";
import { Trans, useTranslation } from "react-i18next";
import { Navigate } from "react-router";

import { useAppConfig } from "~/config/AppConfig";
import { ErrorLayout } from "~/ui/layout/ErrorLayout/ErrorLayout";
import { PublicPageLayout } from "~/ui/layout/PublicPageLayout/PublicPageLayout";
import { useIsAuthorized } from "~/ui/routes/RouteGuards/useIsAuthorized";

import Gandalf from "./assets/gandalf-clean.png";

const NoAccessPage = () => {
  const { t } = useTranslation(undefined, { keyPrefix: "noAccessPage" });

  const appConfig = useAppConfig();
  const { isAuthorized } = useIsAuthorized();

  if (isAuthorized) {
    return <Navigate to={"/"} />;
  }

  const b2bShopUrl = appConfig.links.shop;

  const supportMailTo = `mailto:${appConfig.mail.customerSupport}?subject=${encodeURIComponent(t("mailSubject"))}`;

  return (
    <PublicPageLayout hideNavbarLinks hideUserMenuLinks hideFeedbackButton>
      <ErrorLayout
        title={t("title")}
        subtitle={
          <Trans t={t} i18nKey={"subtitle"}>
            <Anchor href={supportMailTo} />
          </Trans>
        }
        buttonHref={b2bShopUrl}
        buttonLabel={t("button")}
        image={<Image src={Gandalf} alt="Zugriff verweigert" h={"100%"} mah={900} w={"auto"} />}
      />
    </PublicPageLayout>
  );
};

export { NoAccessPage };
